
// src/helpers/store.js

import each from 'lodash/each'
import findIndex from 'lodash/findIndex'
import some from 'lodash/some'
import find from 'lodash/find'

export function stripArray(array) {
  if (array instanceof Array && array.length > 0)
    return array
  else
    return undefined
}

export function mergeArray(key, orig, adding, mode = 'replace_or_append') {
  var result = Object.assign([], orig)

  each(adding, (adding_elm)=> {
    
    var index = findIndex(result, (orig_elm)=> {
      return orig_elm[key] == adding_elm[key]
    })

    if (mode == 'replace_or_append') {
      if (index > -1)
        result[index] = adding_elm
      else
        result.push(adding_elm)
    } else if (mode == 'replace_or_prepend') {
      if (index > -1)
        result[index] = adding_elm
      else
        result.unshift(adding_elm)
    } else if (mode == 'append') {
      if (index > -1)
        result.splice(index, 1)
      result.push(adding_elm)
    } else if (mode == 'prepend') {
      if (index > -1)
        result.splice(index, 1)
      result.unshift(adding_elm)
    } else if (mode == 'discard') {
      if (index > -1)
        result[index] = adding_elm
    }
  })
  // マージした結果、配列の中身に何も変化がなかった場合は、元の配列をそのまま返す
  if (mode == 'discard' && orig && result && orig.length == result.length && !some(Object.keys(result), (i)=> result[i] !== orig[i]))
    return orig

  return result
}

export function deleteArray(key, orig, id) {
  var result = Object.assign([], orig)
  var index = findIndex(result, (elm)=> {
    return elm[key] == id
  })

  if (index > -1)
    result.splice(index, 1)

  return result
}

export function updateArray(key, orig, id, attr, val) {
  var result = Object.assign([], orig)
  var index = findIndex(result, (elm)=> {
    return elm[key] == id
  })
  if (index > -1) {
    if (typeof attr == 'object' || result[index][attr] != val) {
      result[index] = Object.assign({}, result[index], typeof attr == 'object' ? attr : { [attr]: val })
      return result
    }
  }
  return orig
}

export function getArray(key, orig, id) {
  return find(orig, (elm)=> { return elm[key] == id })
}

export function sortArray(orig, attr, order = 1) {
  var result = Object.assign([], orig)
  return result.sort((a, b)=> {
    if (typeof a[attr] == 'undefined')
      return typeof b[attr] == 'undefined' ? 0 : order
    if (typeof b[attr] == 'undefined')
      return -1 * order
    return (a[attr] > b[attr] ? order : (a[attr] == b[attr] ? 0 : -1 * order))
  })
}

export function findTree(key, children, id) {
  for (var i = 0; children && i < children.length; i ++) {
    if (children[i][key] == id)
      return children[i]

    var r = findTree(key, children[i].children, id)
    if (r)
      return r
  }

  return undefined
}

export function replaceTree(key, children, node) {
  for (var i = 0; children && i < children.length; i ++) {
    if (children[i][key] == node[key]) {
      children[i] = node
      return children
    }

    replaceTree(key, children[i].children, node)
  }

  return children
}



// WEBPACK FOOTER //
// ./src/helpers/store.js